import React from "react";
import { Button } from "@chakra-ui/react";
import { BiAnalyse, BiData, BiServer } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import "./Survey.css";

import data from "../../Assets/data.webp";
import server from "../../Assets/server.webp";
import analysis from "../../Assets/analysis.webp";

const Survey = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/services"); 
  };

  return (
    <div className="hospital-section">
      <div className="surveys">
        <div className="images-grid">
          <img src={data} alt="data" />
          <img src={server} alt="server" />
          <img src={analysis} alt="Analysis" />
        </div>

        <div className="content">
          <h5>Simba Education Consultancy Data</h5>
          <h2>ODK Mobile Data Collection</h2>
          <p>
            Simba Education Consultants has embraced mobile data capturing using
            Open Data Kit (ODK), which is a set of open-source tools for managing
            mobile data collection solutions.
          </p>

          <ul className="features-list">
            <li>
              <BiData className="icon" /> Build an ODK data collection form.
            </li>
            <li>
              <BiServer className="icon" /> Collect the data and send it directly
              to a server.
            </li>
            <li>
              <BiAnalyse className="icon" /> Aggregate and export collected data
              for analysis.
            </li>
          </ul>

          <Button className="learn-more-btn" onClick={handleLearnMore}>
            Learn more →
          </Button>
        </div>
      </div>

      <div className="message">
        <div className="message-container">
          <p>
            "As a public health professional, I am committed to improving the
            quality of life in the community by protecting, promoting, and
            maintaining their health. I pass on my expertise in field
            epidemiology and successful disease control strategies to policy
            makers, health managers, public health specialists, researchers,
            paramedical staff, community, and faith-based organizations."
          </p>
          <p>SIMBA EDUCATION CONSULTANCY</p>
          <p>Chairman's Message</p>
        </div>
      </div>
    </div>
  );
};

export default Survey;
